<template>
  <navigation-my-account-component></navigation-my-account-component>
</template>

<script>
import NavigationMyAccountComponent from "./NavigationMyAccountComponent";
import {useAuthUserStore} from "../../stores/auth";
import {useAcademiesStore} from "../../stores/academies";

export default {
  name: "MyAccountComponent",
  components: {NavigationMyAccountComponent},
  setup(){
    const authUserStore = useAuthUserStore();
    const academiesStore = useAcademiesStore()

    return {
      authUserStore,
      academiesStore,
    }
  },
}
</script>

<style scoped>

</style>